import { Link, MasterData } from './contract-notice-dto';
import {
  DivisionDTO,
  DocumentClassDTO,
  TaskDTO,
  BaseEntityDTO,
  MasterDataDTO
} from './plyca-dtos';
import {
  ContractDTO
} from './plyca-dtos-v2';

export class AYMADContractDTO extends ContractDTO {
  greenContract?: Boolean;
  greenContracts?: Array<GreenContractDTO>;
  socialClauses?: Array<SocialClausesDTO>;
  typeGreenContract?: MasterDataDTO;
  fairTrades?: Array<FairTradeDTO>;
  fairTradeType?: MasterDataDTO;
}

export class GreenContractDTO implements BaseEntityDTO {
  division: DivisionDTO;
  documentClass: DocumentClassDTO;
  orderNumber: number;
  links: Link[];
  identifier: any;
  task: TaskDTO;
  taxIdentifier: String;
  selectedCode: MasterDataDTO;
}

export class SocialClausesDTO implements BaseEntityDTO {
  division: DivisionDTO;
  documentClass: DocumentClassDTO;
  orderNumber: number;
  links: Link[];
  identifier: any;
  task: TaskDTO;
  taxIdentifier: String;
  materia: MasterDataDTO;
  category: MasterDataDTO;
  tc: MasterDataDTO;
}

export class FairTradeDTO implements BaseEntityDTO {
  division: DivisionDTO;
  documentClass: DocumentClassDTO;
  orderNumber: number;
  links: Link[];
  identifier: any;
  task: TaskDTO;
  taxIdentifier: String;
  product: MasterDataDTO;
  cjr: MasterDataDTO;
}
